// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default SideNav Styles */
#mySidenav a {
  position: fixed;
  left: -120px;
  transition: 0.3s;
  padding: 15px;
  width: 220px;
  text-decoration: none;
  font-size: 24px;
  border-radius: 0 5px 5px 0;
  z-index: 100;
  opacity: 0.9;
}

#mySidenav a:hover {
  left: 0;
  color: white;
  opacity: 1;
}

/* Button Colors */
#Userbutt {
  top: 20px;
  background-color: #E7B529;
  color: #E7B529;
}

#Weatherbutt {
  top: 80px;
  background-color: #04AA6D;
  color: #04AA6D;
}

#Newsbutt {
  top: 140px;
  background-color: #2196F3;
  color: #2196F3;
}

#leetcodebutt {
  top: 200px;
  background-color: #f44336;
  color: #f44336;
}

#moviebutt {
  top: 260px;
  background-color: #800080;
  color: #800080;
}

#mySidenav button {
  display: none;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  #mySidenav a {
    left: 0px;
    position: absolute;
    transition: 0.3s;
    width: 100%;
    text-decoration: none;
    font-size: 24px;
    border-radius: 0 0 0 0;
    text-align: center;
    background-color: #333; /* Darker shade */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
  }
  #mySidenav.open a {
      top: -70px;
  }

  #Userbutt {
      top: 0px;
  }
  
  #Weatherbutt {
      top: 62px;
  }
  
  #Newsbutt {
      top: 124px;
  }
  
  #leetcodebutt {
      top: 186px;
  }
  
  #moviebutt {
      top: 248px;
  }

  #mySidenav button {
    display: block;
    position: absolute;
    transition: 0.3s;
    left: 0;
    width: 100%;
    text-decoration: none;
    font-size: 24px;
    color: white;
    border-radius: 0 0 0 0;
    text-align: center;
    background-color: #555;
    top: 310px;
    cursor: pointer;
    z-index: 100;
  }
  
  #mySidenav.open button {
    top: 0px;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/User/userSideBar.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB,EAAE,iBAAiB;IACzC,wCAAwC;EAC1C;EACA;MACI,UAAU;EACd;;EAEA;MACI,QAAQ;EACZ;;EAEA;MACI,SAAS;EACb;;EAEA;MACI,UAAU;EACd;;EAEA;MACI,UAAU;EACd;;EAEA;MACI,UAAU;EACd;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;AAEF","sourcesContent":["/* Default SideNav Styles */\r\n#mySidenav a {\r\n  position: fixed;\r\n  left: -120px;\r\n  transition: 0.3s;\r\n  padding: 15px;\r\n  width: 220px;\r\n  text-decoration: none;\r\n  font-size: 24px;\r\n  border-radius: 0 5px 5px 0;\r\n  z-index: 100;\r\n  opacity: 0.9;\r\n}\r\n\r\n#mySidenav a:hover {\r\n  left: 0;\r\n  color: white;\r\n  opacity: 1;\r\n}\r\n\r\n/* Button Colors */\r\n#Userbutt {\r\n  top: 20px;\r\n  background-color: #E7B529;\r\n  color: #E7B529;\r\n}\r\n\r\n#Weatherbutt {\r\n  top: 80px;\r\n  background-color: #04AA6D;\r\n  color: #04AA6D;\r\n}\r\n\r\n#Newsbutt {\r\n  top: 140px;\r\n  background-color: #2196F3;\r\n  color: #2196F3;\r\n}\r\n\r\n#leetcodebutt {\r\n  top: 200px;\r\n  background-color: #f44336;\r\n  color: #f44336;\r\n}\r\n\r\n#moviebutt {\r\n  top: 260px;\r\n  background-color: #800080;\r\n  color: #800080;\r\n}\r\n\r\n#mySidenav button {\r\n  display: none;\r\n}\r\n\r\n/* Responsive Design */\r\n@media screen and (max-width: 768px) {\r\n  #mySidenav a {\r\n    left: 0px;\r\n    position: absolute;\r\n    transition: 0.3s;\r\n    width: 100%;\r\n    text-decoration: none;\r\n    font-size: 24px;\r\n    border-radius: 0 0 0 0;\r\n    text-align: center;\r\n    background-color: #333; /* Darker shade */\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);\r\n  }\r\n  #mySidenav.open a {\r\n      top: -70px;\r\n  }\r\n\r\n  #Userbutt {\r\n      top: 0px;\r\n  }\r\n  \r\n  #Weatherbutt {\r\n      top: 62px;\r\n  }\r\n  \r\n  #Newsbutt {\r\n      top: 124px;\r\n  }\r\n  \r\n  #leetcodebutt {\r\n      top: 186px;\r\n  }\r\n  \r\n  #moviebutt {\r\n      top: 248px;\r\n  }\r\n\r\n  #mySidenav button {\r\n    display: block;\r\n    position: absolute;\r\n    transition: 0.3s;\r\n    left: 0;\r\n    width: 100%;\r\n    text-decoration: none;\r\n    font-size: 24px;\r\n    color: white;\r\n    border-radius: 0 0 0 0;\r\n    text-align: center;\r\n    background-color: #555;\r\n    top: 310px;\r\n    cursor: pointer;\r\n    z-index: 100;\r\n  }\r\n  \r\n  #mySidenav.open button {\r\n    top: 0px;\r\n  }\r\n  \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
